import { Component } from '@angular/core';

@Component({
  selector: 'next-meeting-template',
  templateUrl: './next-meeting-template.component.html',
  styleUrls: ['../../../meeting-form.component.scss', '../../form-steps.scss']
})
export class NextMeetingTemplateComponent {
  opened = false
}
